import FeatureGates from "@atlassian/feature-gate-js-client";
import { ProductKeys } from "@atlassiansox/asc-stargate";

import { CrossFlowTouchpointProvider } from "@/components/cross-flow/touchpoint";
import { IntercomProvider } from "@/libraries/intercom/src";
import { ConfluencePricingPageTemplate } from "@/templates/confluence-pricing-page/src";

import { AppPricingData } from "../../../../contentful";
import { UserLocale } from "../../../../utils/useGeoCurrency";

export type ConfluencePricingPageProps = {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
};

export const ConfluencePricingPage = ({
    pricing,
    countryCode
}: ConfluencePricingPageProps) => {
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom: boolean = FeatureGates.checkGate(
        "gwp-737-enable-intercom-chat-confluence"
    );

    return (
        <IntercomProvider appId={"p0ww63i2"} triggerBoot={isBootIntercom}>
            <CrossFlowTouchpointProvider productKeys={[ProductKeys.CONFLUENCE]}>
                <ConfluencePricingPageTemplate
                    pricing={pricing}
                    countryCode={countryCode}
                />
            </CrossFlowTouchpointProvider>
        </IntercomProvider>
    );
};
